const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const { PRODUCTION_ENVIRONMENT } = require('constants/index');
const { recordLinkCommonV2 } = require('commonsUtilities/tagging')
const { FormattedText, formatText } = require('core/i18n').i18n;
const { OKButton } = require('commonsComponents/OKButton');
const { formatAmount } = require('utilities/currencyHelper');


const UserNotInvestedBox = ({ fund, history, isAlternativeFund }) => {
    const isNotProduction = __ENVIRONMENT__ !== PRODUCTION_ENVIRONMENT;
    const buyButtonFund = (isAlternativeFund) => {
        if (isAlternativeFund) {
            recordLinkCommonV2({
                categoriaEvento: `ficha fondo alternativo/${fund.name}`,
                accionEvento: "clickButton", 
                etiquetaEvento: "comprar",
            }, isNotProduction);
        } else {
            recordLinkCommonV2({
                categoriaEvento: 'broker/fund',
                accionEvento: 'funds card',
                etiquetaEvento: 'comprar',
            }, isNotProduction);
        }

        isAlternativeFund 
        ? history.push(`/myprofile/broker/buyAlternativeInvestmentFunds/${fund.isin}`)
        : history.push(`/myprofile/broker/buyInvestmentFunds/${fund.customInstitutionSecurityId}`)
    }

    if (!isAlternativeFund) {
        return (
            <div className="user-fund-box__user-not-invested-box">
                <section className="purse__summary">
                    <p className="summary--total">
                        {formatText("fundsCard-noSharesMessage")}
                    </p>
                    <p className="summary--percent">
                        <span className="percent--title">
                            <FormattedText
                                value="fundsCard-percentageInWallet"
                                injectedStrings={[0]}
                            />
                        </span>
                    </p>
                    <p className="summary--amount">
                        <span className="amount--bold">
                            {formatAmount(0)}&nbsp;EUR
                        </span>
                        &nbsp;
                        <span>{formatAmount(0)}&nbsp;%</span>
                    </p>
                </section>
                <section className="purse__rentability">
                    <p className="rentability--title">
                        {formatText("fundsCard-accProfitability")}
                    </p>
                    <p className="rentability--amount">
                        &nbsp;
                        <span className="amount--bold">
                            +{formatAmount(0)}&nbsp;EUR
                        </span>
                    </p>
                    {" | "}
                    <p className="rentability--percent">
                        <span className="percent--bold">
                            &nbsp;{formatAmount(0)}%
                        </span>
                    </p>
                </section>
                <section className="purse__actions">
                    {fund.custom && fund.custom.customCategoryId3 && (
                        <OKButton
                            modifier="primary"
                            onClick={() => buyButtonFund()}
                        >
                            {formatText("fundsCard-buyButton")}
                        </OKButton>
                    )}
                </section>
            </div>
        );
    } else {
        return (
            <div className="user-fund-box__user-not-invested-box">
                <section className="purse__summary">
                    <p className="summary--total">
                        {formatText('brokerAlternativeFundsCard-noSharesMessage')}
                    </p>
                </section>
                <section className="description">
                    <p>{formatText('brokerAlternativeFundsCard-noTransferComision')}</p>
                    <p>{formatText('brokerAlternativeFundsCard-noSuscriptionComision')}</p>
                    <p>{formatText('brokerAlternativeFundsCard-noCustodyComision')}</p>
                    <p>{formatText('brokerAlternativeFundsCard-noRefundComision')}</p>
                </section>
                <section className="buttons__container">
                    {fund.marketable && (
                        <OKButton
                            modifier="primary"
                            onClick={() => buyButtonFund(isAlternativeFund)}
                        >
                            {formatText("fundsCard-buyButton")}
                        </OKButton>
                    )}
                </section>
            </div>
        );
    }
}


UserNotInvestedBox.propTypes = {
    fund: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    isAlternativeFund: PropTypes.bool,
};


module.exports = withRouter(UserNotInvestedBox);
